@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
    background-color: var(--light-beige);
}

.tabs {
    grid-column: 1 / -1;
}

.tabList {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    box-shadow: inset 0 -1px 0 0 var(--gray);
}

.tab {
    composes: fontButton from "../../styles/composable/typography.module.css";
    composes: outline from "../../styles/composable/utility.module.css";
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    box-shadow: inset 0 -1px 0 0 var(--gray);
    padding: var(--spacer-8) var(--spacer-56);
    text-align: center;
    transition:
        box-shadow 0.2s,
        color 0.2s;

    &[aria-selected="true"] {
        box-shadow: inset 0 -2px 0 0 var(--red);
    }

    &[data-hovered] {
        color: var(--red);
    }
}

.panel {
    padding: var(--spacer-48);
}

.ctaContainer {
    margin-top: var(--spacer-32);
    display: flex;
    place-content: center;
}
